import { render, staticRenderFns } from "./CorrespondenceThreadsTable.vue?vue&type=template&id=e36a4d6a&"
import script from "./CorrespondenceThreadsTable.vue?vue&type=script&lang=js&"
export * from "./CorrespondenceThreadsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports